import { render, staticRenderFns } from "./StatoVoucher.vue?vue&type=template&id=a43e9770&scoped=true"
import script from "./StatoVoucher.vue?vue&type=script&lang=js"
export * from "./StatoVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43e9770",
  null
  
)

export default component.exports